<template>
  <div class="create_report_choose white_box mb_16">
    <h4 class="heading_h4 font_bold mb_16">
      Create your first report
    </h4>
    <div class="choose_report_type">
      <div
        :class="'white_box report_type_item'"
        @click="$emit('create', 'blank')"
      >
        <div class="icon mb_16">
          <svg
            fill="none"
            height="32"
            viewBox="0 0 32 32"
            width="32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25 28H6.99902C6.73381 28 6.47945 27.8946 6.29192 27.7071C6.10438 27.5196 5.99902 27.2652 5.99902 27V5C5.99902 4.73478 6.10438 4.48043 6.29192 4.29289C6.47945 4.10536 6.73381 4 6.99902 4H19L26 11V27C26 27.1313 25.9741 27.2614 25.9239 27.3827C25.8736 27.504 25.8 27.6143 25.7071 27.7071C25.6143 27.8 25.504 27.8736 25.3827 27.9239C25.2614 27.9741 25.1313 28 25 28Z"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
            <path
              d="M19 4V11H26.001"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
          </svg>
        </div>
        <div>
          <div class="heading_h5 font_bold mb_4">
            Create a blank report
          </div>
          <p class="p_small">
            Start fresh from a clean slate and add sections.
          </p>
        </div>
      </div>
      <div
        :class="'white_box report_type_item'"
        @click="$emit('create', 'template')"
      >
        <div class="icon mb_16">
          <svg
            fill="none"
            height="32"
            viewBox="0 0 32 32"
            width="32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25 28H6.99902C6.73381 28 6.47945 27.8946 6.29192 27.7071C6.10438 27.5196 5.99902 27.2652 5.99902 27V5C5.99902 4.73478 6.10438 4.48043 6.29192 4.29289C6.47945 4.10536 6.73381 4 6.99902 4H19L26 11V27C26 27.1313 25.9741 27.2614 25.9239 27.3827C25.8736 27.504 25.8 27.6143 25.7071 27.7071C25.6143 27.8 25.504 27.8736 25.3827 27.9239C25.2614 27.9741 25.1313 28 25 28Z"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
            <path
              d="M19 4V11H26.001"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
            <path
              d="M12 17H20"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
            <path
              d="M12 21H20"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
          </svg>
        </div>
        <div>
          <div class="heading_h5 font_bold mb_4">
            Start from a template
          </div>
          <p class="p_small">
            Use a premade template or one of your own.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  emits: ['create'],
  data() {
    return {}
  },
}
</script>

<style scoped>
.create_report_choose .heading_h4 {
  text-align: center;
}

.choose_report_type {
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: 0 auto;
}

.report_type_item {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 1.5rem;
  padding-bottom: 2rem;
  border: 1px solid #E8E5E2;
  cursor: pointer;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  margin: 0 1rem;
}

.report_type_item:not(:last-of-type) {
  margin-right: 1.5rem;
}

.white_box {
  background-color: white;
  border-radius: 0.75rem;
  padding: 2rem;
}

.report_type_item .icon {
  width: 4rem;
  height: 4rem;
  background-color: #DFF5EE;
  border-radius: 0.75rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
</style>
